module.exports = __webpack_public_path__ + "media/images/default/lp_about_buyer-addb4da57e1853ee6d20ba3a457dccf0.svg";